import Networking from '../../../utils/api/apiaccess';
import labels from '../../../utils/constants/labels';
import apiurl from '../../url/apiurl';
var axios = require('axios');
function camsEtlProcess(clientID,batchNo) {

    return Networking.PostApi(`${apiurl.camsEtlProcess}?clientId=${clientID}&batchNo=${batchNo}`, "",labels.apiKey.apiKeys).then(result => { return result })
        .catch(function (error) {
            return { "status": "F", "message": labels.messages.apierror }
        });

}
export default camsEtlProcess
